<template>
    <div>
        <div id="JuzgadoYTramites_div" class="w-100">
            <div class="row">
                <!-- Apartado de selects de Juzgado/Materia/TiposTramites -->
                <div id="juzgadoMateriaTramite_div" class="col-12 col-sm-12 col-md-12 col-lg-4 col-xlg-3" >
                    
                    <div v-bind:class="[ agregandoExpedientes || limiteDeExpedientes ? 'wrapDivBloqueado': '']">
                        <h5 class="card-header">Ingrese</h5>
                        <div v-bind:class="[ agregandoExpedientes || limiteDeExpedientes ? 'area bloquearDiv card-body': 'area card-body']">
                            
                            <hr />
                            <!-- Juzgado -->
                            <div id="areas">
                                <h6 class="text-form">Juzgado&nbsp;<i style="cursor: pointer" class="fas fa-info-circle " @click="mostrarMensajeJuzgado = !mostrarMensajeJuzgado"></i></h6>
                                <div id="aviso-juzgado-materia" v-if="mostrarMensajeJuzgado" class="mb-2">
                                    <h6 class="text-form-note"><i class="fas fa-info-circle"></i>&nbsp;Nota</h6>
                                    <span style="text-align: justify; display:block;">{{MENSAJE_AVISO_JUZGADO}}</span>
                                </div>
                                <div class="col-9 form-control">
                                <CAreas  
                                    v-on:valorParaElPadre="cambioArea" 
                                    :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                    :tipo="enumeraciones.tiposDeSelect.Seleccione"
                                    :idDelInput="'catalogoAreas'" 
                                    :parametros="parametros_Areas" 
                                    :valorDefinido="verificarValorId(parametros_Areas.AreaSelecccionadaId)? parametros_Areas.AreaSelecccionadaId : parametros_Areas.ValorDefinido"
                                    >
                                </CAreas>
                                </div>
                                <!-- <div id="aviso-juzgado-materia" v-if="verificarValorId(parametros_Areas.AreaSelecccionadaId) && (parametros_Areas.AreaPJSeleccionadaId == 17 || parametros_Areas.AreaPJSeleccionadaId == 18 || parametros_Areas.AreaPJSeleccionadaId == 24 || parametros_Areas.AreaPJSeleccionadaId == 29)" class="mb-2"> 
                                    
                                    <h6 class="text-warning"><i class="fas fa-info-circle text-warning"></i>&nbsp;Nota</h6>
                                    <span style="text-align: justify; display:block;" class="text-warning">Si quiere realizar un trámite de 'Diligencia de Ministro Ejecutor' favor de solicitar su cita al correo <b style="font-size:1.2em;">actuariapabellon@poderjudicialags.gob.mx</b></span>
                                </div> -->
                                <br>
                                <div class="clearfix mb-3">
                                    <div class="float-right ancho_botones">
                                        <button v-if="verificarValorId(parametros_Areas.AreaSelecccionadaId) && parametros_Areas.deshabilitarSelectAreas" type="button" class="btn btn-primary px-3" @click="verificarParaHabilitarSelectAreas()"><i class="fas fa-exchange-alt fa-lg"></i>&nbsp;&nbsp;Cambiar Juzgado</button>
                                    </div> 
                                </div>  
                            </div>
                            <!-- Materia -->
                            <div id="materias" v-if="verificarValorId(parametros_Areas.AreaSelecccionadaId) && parametros_Areas.deshabilitarSelectAreas">
                                <hr />
                                <h6 class="text-form">Materia</h6>
                                <CMaterias  
                                    v-on:valorParaElPadre="triggerCambioMateria" 
                                    :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                    :tipo="enumeraciones.tiposDeSelect.Ninguno" 
                                    :idDelInput="'catalogoMaterias'" 
                                    :parametros="parametros_Materias" 
                                    :valorDefinido="verificarValorId(parametros_Materias.MateriaSelecccionadaId)? parametros_Materias.MateriaSelecccionadaId : parametros_Materias.ValorDefinido"
                                    :key="parametros_Areas.AreaSelecccionadaId"
                                    >
                                </CMaterias>
                            </div>
                            <hr />
                            <!-- Tipos de trámites -->
                            <div id="tiposTramites" v-if="verificarValorId(parametros_Materias.MateriaSeleccionadaId) && parametros_Materias.deshabilitarSelectMaterias && verificarValorId(parametros_Areas.AreaSelecccionadaId) && parametros_Areas.deshabilitarSelectAreas">
                                <h6 class="text-form-note">Trámite&nbsp;<i class="fas fa-info-circle"></i></h6>
                                <div id="aviso-juzgado-materia" v-if="mostrarMensajeLimiteExpedientes" class="mb-2">
                                    <h6 class="text-form-note"><i class="fas fa-info-circle"></i>&nbsp;Nota</h6>
                                    <span class="text-form-note" style="text-align: justify; display:block;">{{MENSAJE_LIMITE_EXPEDIENTES}}{{limiteExpedientesDefault}}{{MENSAJE_COUNTINUACION_LIMITE_EXPEDIENTES}}</span>
                                </div>
                                <CTiposTramites  
                                    v-on:valorParaElPadre="cambioTipoTramite" 
                                    :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                    :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                    :idDelInput="'catalogoTiposTramites'" 
                                    :parametros="parametros_TiposTramites" 
                                    :valorDefinido="verificarValorId(parametros_TiposTramites.TipoTramiteSeleccionadoId)? parametros_TiposTramites.TipoTramiteSeleccionadoId : parametros_TiposTramites.ValorDefinido"
                                    :key="parametros_TiposTramites.TipoTramiteSeleccionadoId"
                                    >
                                </CTiposTramites> 
                                <div class="clearfix mb-3">
                                    <div class="float-right ancho_botones">
                                        <button id="botonCrearTramite" v-if="verificarValorId(parametros_TiposTramites.TipoTramiteSeleccionadoId)" type="button" class="btn btn-success" @click="habilitarSeccionExpedientes()"><i class="fas fa-edit fa-lg"></i>&nbsp;&nbsp;Crear Trámite</button>
                                    </div> 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Apartado ingresar información de trámite y Tabla de tramites -->
                <div id="tramitesExpedientes_div" class="col-12 col-sm-12 col-md-12 col-lg-8 col-xlg-9  pt-sm-4 pt-md-4 pt-lg-0 pt-xlg-0">
                    <!-- Información de trámite -->
                    <transition name="fadeHeight" mode="out-in">

                        <div v-if="agregandoExpedientes">
                            <h5 class="card-header">Ingrese la información referente a su trámite</h5>
                        <div class="area mb-4 card-body">                            
                                
                            <hr />
                            <div class="contenedor-puntero">
                                <h6 >[Agregando expedientes para {{parametros_Temporales.TipoTramite}} en Materia {{parametros_Temporales.Materia}}]</h6>
                            </div>
                            <div v-if="contadorTemporalExpedientesDeCita >= limiteExpedientesDefault">
                                <h6 class="text-center mb-3 text-danger text-form">Ha llegado al límite de expedientes permitidos. Si desea agregar otro, tendrá que eliminar uno existente.</h6>
                            </div>
                            <div v-else id="informacionAgregarExpediente_div">
                                <div class="campos_expedientes">
                                    <h6 class="text-form">Tipo de documento</h6>
                                    <CTiposDocumentos
                                        v-on:valorParaElPadre="triggerCambioTipoDocumento"
                                        id="tiposDocs"
                                        :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                        :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                        :class="[!verificarValorId(parametros_TiposDocumentos.TipoDocumentoSeleccionadoId) && mostrarErrores ? 'border border-danger':'', 'espacio_base']"
                                        :idDelInput="'catalogoTiposDocumentos'" 
                                        :parametros="parametros_TiposDocumentos" 
                                        :valorDefinido="verificarValorId(parametros_TiposDocumentos.TipoDocumentoSeleccionadoId)? parametros_TiposDocumentos.TipoDocumentoSeleccionadoId : parametros_TiposDocumentos.ValorDefinido" 
                                        :key="parametros_TiposDocumentos.AreaId +'-'+ parametros_TiposDocumentos.MateriaId"
                                    >
                                    </CTiposDocumentos>
                                </div>
                                <div class="campos_expedientes">
                                    <h6 class="text-form">Expediente</h6>
                                    <input 
                                        type="text" 
                                        id="numeroDelExpediente" 
                                        v-model="numeroDelExpediente" 
                                        :class="[!verificarExpediente(false) && mostrarErrores ? 'border border-danger':'', 'form-control espacio_base']"
                                        v-mask="vmaskNumeroExpediente"  
                                        placeholder="0150/2020"
                                    />
                                </div>
                                <div class="col-12" style="margin-bottom: 10px;">
                                    <div class="clearfix">
                                        <button type="button" class="btn btn-primary float-right" @click="agregarExpediente()"><i class="fas fa-file-medical fa-lg"></i>&nbsp;&nbsp;Agregar Expediente</button>
                                    </div> 
                                </div>
                            </div>
                            <div id="tablaDeExpedientes_div" class="table-responsive col-12">
                                <div id="tablaDeExpedientes_texto_div">
                                    <span></span>
                                </div>
                                <table class="table table-striped table-light table-hover table-bordered table-condensed" id="tablaDeExpedientes_table" 
                                    data-search="false" 
                                    data-toggle="tablaDeExpedientes_table" 
                                    data-pagination="false" 
                                    data-toolbar="#tablaDeExpedientes_texto_div"
                                    data-page-size="5"
                                    data-page-list="[2,5,10]"
                                    data-undefined-text="Sin información"
                                    data-minimum-count-columns="0">
                                    <thead class="table-header-global">
                                        <tr>
                                            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%" class="text-center">#</th>
                                            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:40%" class="text-center">Tipo de documento</th>
                                            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:30%" class="text-center">Número de Expediente</th>
                                            <th v-if="!verificarValorId(parametros_TiposDocumentos.TipoDocumentoSeleccionadoId) && numeroDelExpediente=='' && verificarListadoConInformacion(listadoExpedientes)" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%" class="text-center">Modificar</th>
                                            <th v-if="verificarListadoConInformacion(listadoExpedientes)" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%" class="text-center">Eliminar</th>
                                        </tr>
                                    </thead>
                                    <tbody class="text-dark">
                                        <tr v-if="!verificarListadoConInformacion(listadoExpedientes)">
                                            <td colspan="3" class="text-center">No ha agregado ningún expediente aún</td>
                                        </tr>
                                        <tr v-else v-for="(Expediente, index) in listadoExpedientes" :key="'Expediente' + index">
                                            <td class="text-center">{{index+1}}</td>
                                            <td class="text-center">{{Expediente.tipoDeDocumento}}</td>
                                            <td class="text-center">{{Expediente.NumeroDeExpediente}}</td>
                                            <td v-if="!verificarValorId(parametros_TiposDocumentos.TipoDocumentoSeleccionadoId) && numeroDelExpediente==''" class="text-center"><i class="fas fa-edit fa-lg" @click="modificarExpediente(index)" style="cursor:pointer;"></i></td>
                                            <td class="text-center"><i class="fas fa-trash-alt fa-lg" @click="eliminarExpediente(index)" style="cursor:pointer;"></i></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <hr />
                            <div class="clearfix"> 
                                <div class="float-left ancho_botones">
                                    <button type="button" class="btn btn-primary px-3" @click="cancelarTramite()"><i class="far fa-minus-square fa-lg"></i>&nbsp;&nbsp;Cancelar Trámite</button>
                                </div> 
                                <div v-if="parametros_TiposTramites.TipoTramiteSeleccionadoId == 6 || verificarListadoConInformacion(listadoExpedientes)" class="float-right ancho_botones">
                                    <button type="button" class="btn btn-primary px-3" @click="agregarTramite()"><i class="far fa-plus-square fa-lg"></i>&nbsp;&nbsp;Agregar Trámite</button>
                                </div> 
                            </div>
                        </div>
                        </div>
                    </transition>
                    <!-- Tabla de tramites a realizar -->
                    <h5 class="card-header">Trámites a realizar</h5>
                    <div class="area card-body">
                        
                        <h6 v-if="verificarValorId(parametros_Areas.AreaSelecccionadaId) && parametros_Areas.deshabilitarSelectAreas" class="text-secondary text-form">Expedientes: {{contadorExpedientesDeCita}} de {{limiteExpedientesDefault}}</h6>
                        <hr />
                        <div id="aviso-tramite-excede-tiempo" class="mb-2 mx-3 mt-3" v-if="mensajeTiempoExcede">
                            <h6 class="text-form-note"><i class="fas fa-info-circle "></i>&nbsp;Nota</h6>
                            <span style="text-align: justify; display:block;">Ha seleccionado un trámite que requiere un tiempo de al menos {{tiempoExcede}} minutos, la agenda se cargará de acuerdo a ello.</span>
                        </div>
                        <div id="tablaDeTramites_div" class="table-responsive col-12">
                            <div id="tablaDeTramites_texto_div">
                                <span></span>
                            </div>
                            <table class="table table-striped table-light table-hover table-bordered table-condensed" id="tablaDeTramites_table" 
                                data-search="false" 
                                data-toggle="tablaDeTramites_table" 
                                data-pagination="false" 
                                data-toolbar="#tablaDeTramites_texto_div"
                                data-page-size="5"
                                data-page-list="[2,5,10]"
                                data-undefined-text="Sin información"
                                data-minimum-count-columns="0">
                                <thead class="table-header-global">
                                    <tr>
                                        <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:9%" class="text-center">#</th>
                                        <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:26%" class="text-center">Trámite</th>
                                        <th v-if="mostrarMateriaEnListado" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:12%" class="text-center">Materia</th>
                                        <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:35%" class="text-center">Expedientes</th>
                                        <th v-if="!agregandoExpedientes && verificarListadoConInformacion(informacionTramitesExpedientesYConfiguracion.ListadoTramites)" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:9%" class="text-center">Modificar</th>
                                        <th v-if="!agregandoExpedientes && verificarListadoConInformacion(informacionTramitesExpedientesYConfiguracion.ListadoTramites)" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:9%" class="text-center">Eliminar</th>
                                    </tr>
                                </thead>
                                <tbody class="text-dark">
                                    <tr v-if="!verificarListadoConInformacion(informacionTramitesExpedientesYConfiguracion.ListadoTramites)">
                                        <td colspan="4" class="text-center">No ha agregado ningún trámite aún</td>
                                    </tr>
                                    <tr v-else v-for="(Tramite, index) in informacionTramitesExpedientesYConfiguracion.ListadoTramites" :key="'Tramite'+index">
                                        <td class="text-center align-middle">{{index+1}}</td>
                                        <td class="text-center align-middle">{{Tramite.nombre}}</td>
                                        <td v-if="mostrarMateriaEnListado" class="text-center align-middle">{{Tramite.materiaNombre}}</td>
                                        <td>
                                            <ul v-if="Tramite.TipoTramiteId != 6" id="listado_expedientes" class="mb-0">
                                                <li v-for="Expediente in Tramite.Expedientes" :key="Expediente.NumeroDeExpediente">
                                                    {{Expediente.tipoDeDocumento}} : {{Expediente.NumeroDeExpediente}}
                                                </li>
                                            </ul>
                                            <p v-else class="mb-0 text-center">NO APLICA</p>
                                        </td>
                                        <td v-if="!agregandoExpedientes && verificarListadoConInformacion(informacionTramitesExpedientesYConfiguracion.ListadoTramites)" class="text-center align-middle">
                                            <i v-if="Tramite.TipoTramiteId != 6" class="fas fa-edit fa-lg" @click="modificarTramite(index)" style="cursor:pointer;"></i>
                                            <i v-else class="fas fa-edit fa-lg" style="cursor:default; color:gray;"></i>
                                        </td>
                                        <td v-if="!agregandoExpedientes && verificarListadoConInformacion(informacionTramitesExpedientesYConfiguracion.ListadoTramites)" class="text-center align-middle"><i class="fas fa-trash-alt fa-lg" @click="eliminarTramite(index)" style="cursor:pointer;"></i></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div id="NotasDelSolicitante_div" class="col-12 pt-1" v-if="verificarListadoConInformacion(informacionTramitesExpedientesYConfiguracion.ListadoTramites)">
                            <h6>Notas, observaciones o información extra referente a sus trámites:</h6>
                            <textarea  
                                v-model="informacionTramitesExpedientesYConfiguracion.NotasDelSolicitante"
                                type="text" 
                                rows="3" 
                                id="notasSolicitante" 
                                :class="['form-control']" 
                                placeholder="De ser requerido, ingrese información extra." 
                            />
                        </div>
                        <hr />
                        <!-- <div v-if="!agregandoExpedientes" class="clearfix">
                            <div class="float-left ancho_botones">
                                <button type="button" class="btn btn-primary overwrapDeBotones px-3"  @click="cancelarCita()"><i class="far fa-calendar-times fa-lg"></i>&nbsp;&nbsp;Cancelar cita</button>
                            </div> 
                            <div v-if="verificarListadoConInformacion(informacionTramitesExpedientesYConfiguracion.ListadoTramites)" class="float-right ancho_botones">
                                <button type="button" class="btn btn-primary overwrapDeBotones px-3" @click="crearObjetoYSiguiente()"><i class="fas fa-arrow-alt-circle-right fa-lg"></i>&nbsp;&nbsp;Seleccionar Fecha</button>
                            </div> 
                            <div class="float-right ancho_botones">
                                <button type="button" class="btn btn-primary mr-3 overwrapDeBotones px-3" @click="regresarADatosSolicitante()"><i class="fas fa-arrow-alt-circle-left fa-lg"></i>&nbsp;&nbsp;Regresar</button>
                            </div> 
                        </div> -->
                        <div v-if="!agregandoExpedientes" class="d-flex row">
                            <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xlg-4 pb-2 text-left">
                                <button type="button" class="btn btn-primary overwrapDeBotones"  @click="cancelarCita()"><i class="far fa-calendar-times fa-lg"></i>&nbsp;&nbsp;Cancelar cita</button>
                            </div> 
                            <div class="d-sm-none d-md-none d-lg-block col-lg-1 col-xlg-1"></div>
                            <div class="col-12 col-sm-12 col-md-8 col-lg-7 col-xlg-7 pb-1 text-right">
                                <button type="button" class="btn btn-primary overwrapDeBotones mb-1" @click="regresarADatosSolicitante()"><i class="fas fa-arrow-alt-circle-left fa-lg"></i>&nbsp;&nbsp;Regresar</button>
                                <button v-if="verificarListadoConInformacion(informacionTramitesExpedientesYConfiguracion.ListadoTramites)" type="button" class="btn btn-primary overwrapDeBotones mb-1" @click="crearObjetoYSiguiente()"><i class="fas fa-arrow-alt-circle-right fa-lg"></i>&nbsp;&nbsp;Seleccionar Fecha</button>
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import router from '@/../src/router/index'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'

  export default {
    components: {
        CAreas: catalogos.SICCIJ.C001Areas,
        CMaterias: catalogos.PJ.C002Materias,
        CTiposTramites: catalogos.SICCIJ.C013TiposTramites,
        CTiposDocumentos: catalogos.PJ.C004TipoDocumento
    },
    data() {
        return {
            enumeraciones,
            catalogos,
            parametros_Areas: {
                ValorDefinido : -1,
                AreaSelecccionadaId: null,
                AreaId: null,
                AreaPJSeleccionadaId: null,
                ConInactivas: false,
                ConMateriasDeAreaPJ: true,
                ConOrdenamiento: true,
                deshabilitarSelectAreas: false,
                nombre:""
            },
            parametros_Materias: {
                ValorDefinido: -1,
                MateriaId: null,
                MateriaSeleccionadaId: null,
                AreaId : null,
                ConInactivos: false,
                deshabilitarSelectMaterias: false,
                nombre:""
            },
            parametros_TiposTramites:{
                ValorDefinido : -1,
                TipoTramite: null,
                TipoTramiteId: null,
                AreaId: null,
                TipoTramiteSeleccionadoId: null,
                ConInactivos: false,
                mostrarBoton: false,
                nombre:""
            },
            parametros_TiposDocumentos: {
                ValorDefinido : -1,
                TipoDocumentoId: null,
                TipoDocumentoSeleccionadoId: null,
                AreaId: null,
                MateriaId:null,
                soloDocumentosPrincipales: true,
                nombre:""
            },
            parametros_ConfiguracionCitasDeArea:{
                AreaId: null
            },
            parametros_Temporales:{
                MateriaId:null,
                Materia:"",
                TipoTramiteId:null,
                TipoTramite:""
            },
            mostrarMateriaEnListado: false,
            vmaskNumeroExpediente:'####/####',
            tipoNumExpedienteEspecial: false,
            listadoExpedientes:[],
            agregandoExpedientes: false,
            limiteDeExpedientes: false,
            numeroDelExpediente:"",
            mensajeTiempoExcede:false,
            tiempoExcede: null,
            contadorTramitesQueExcedenTiempo:0,
            mostrarErrores:false,
            mostrarMensajeJuzgado: false,
            informacionTramitesExpedientesYConfiguracion:{
                NotasDelSolicitante:"",
                ListadoTramites:[]
            },
            contadorExpedientesDeCita: 0,
            contadorTemporalExpedientesDeCita: 0,
            MENSAJE_AVISO_JUZGADO: 'Se le recuerda que si decide cambiar de juzgado los trámites que haya ingresado se perderán, asegúrese de seleccionar el juzgado adecuado antes de continuar.',
            mostrarMensajeLimiteExpedientes: true,
            limiteExpedientesDefault: 2,
            MENSAJE_LIMITE_EXPEDIENTES: 'El límite de expedientes por cita es ',
            MENSAJE_COUNTINUACION_LIMITE_EXPEDIENTES: ', una vez llegado al límite no podrá agregar más trámites y/o expedientes a menos que elimine uno existente.'
        }
    },
    props: {
      parametros: 
      {
        peticion:Object
      }
    },
    methods: {
        /**
         * Función encargada de cambiar el área cuando el componente desencadena el evento de cambio en el select
         * @param {Array} datos [tiene dos valores, el primero el evento del cambio de área y el segundo el objeto del área seleccionada]
         */
        cambioArea(datos) {
            var datosEvento = datos[0];
            var objetoArea = datos[1];
            this.parametros_Areas.AreaSelecccionadaId = parseInt(datosEvento.target.value);
            this.parametros_Areas.AreaPJSeleccionadaId = objetoArea.AreaId_001DBPJ;
            this.parametros_Materias.AreaId = objetoArea.AreaId_001DBPJ;
            this.parametros_TiposDocumentos.AreaId = objetoArea.AreaId_001DBPJ;
            if(this.parametros_Areas.AreaSelecccionadaId > 0)
            {
                this.parametros_Areas.deshabilitarSelectAreas = true;
                this.parametros_ConfiguracionCitasDeArea.AreaId = parseInt(datosEvento.target.value);
                this.parametros_TiposTramites.AreaId = parseInt(datosEvento.target.value);
                this.informacionTramitesExpedientesYConfiguracion.AreaId = parseInt(datosEvento.target.value);
                this.parametros.peticion.AreaId = parseInt(datosEvento.target.value);
                this.informacionTramitesExpedientesYConfiguracion.NombreArea = $("#catalogoAreas option:selected").text();
                this.habilitarSelectMaterias();
                //this.parametros_Materias.MateriaSeleccionadaId = null;
                this.mostrarMateriaEnListado = false;
                if(objetoArea.Area_PJ.Materias!= undefined && objetoArea.Area_PJ.Materias!= null && objetoArea.Area_PJ.Materias.length > 0)
                {
                    if(objetoArea.Area_PJ.Materias.length == 1)
                    {
                        this.parametros_Materias.ValorDefinido = objetoArea.Area_PJ.Materias[0].MateriaId;
                         this.parametros_Materias.nombre = objetoArea.Area_PJ.Materias[0].Nombre;
                        this.parametros_Temporales.Materia = objetoArea.Area_PJ.Materias[0].Nombre;
                    }
                    else
                    {
                        this.parametros_Materias.ValorDefinido = objetoArea.Area_PJ.Materias[1].MateriaId;
                        this.mostrarMateriaEnListado = true;
                        this.parametros_Materias.nombre = objetoArea.Area_PJ.Materias[1].Nombre;
                        this.parametros_Temporales.Materia = objetoArea.Area_PJ.Materias[1].Nombre;
                    }
                    $('#catalogoTiposTramites').val(-1);
                    this.parametros_TiposTramites.TipoTramiteSeleccionadoId = null;
                    this.cambioMateria(this.parametros_Materias.ValorDefinido);
                   
                }
                else
                    comun.mensajeDeAlerta("No se encontraron las materias del area seleccionada.", null, null);
                $("#catalogoAreas").attr('disabled','disabled');
                this.verificarJuzgadoDisponible();
            }
        },
        /**
         * Función encargada de llamar a API para verificar que el juzgado esté disponible.
         */
        verificarJuzgadoDisponible: function () {
            comun.SeEstaCargandoInformacion(true);
            this.parametros.peticion.EsPrueba= this.enumeraciones.EsPrueba;
            const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false); 

            axios.post(api.conexion + api.SICCIJ.sistema.citas.AgendarCita.VerificarDisponibilidadJuzgado,
            this.parametros.peticion,
            headerPeticion
            ).then(respuesta => {
                if (respuesta.data.SiHayError) {
                    console.log(respuesta);
                    comun.SeEstaCargandoInformacion(false);
                    bootbox.confirm({
                        title: "Mensaje del sistema",
                        message: respuesta.data.Error.Mensaje,
                        buttons: {
                            cancel: {
                            label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Elegir otro juzgado'
                            },
                            confirm: {
                            label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Cancelar agenda de cita'
                            }
                        },
                        callback: (respuestaCancelarCita) => {
                            if (respuestaCancelarCita) {
                                comun.SeEstaCargandoInformacion(true);
                                this.$router.go();
                            }
                            else
                                this.habilitarSelectAreas();
                        }
                    });            
                }   
                else{
                    comun.SeEstaCargandoInformacion(false);
                    this.obtenerConfiguracionesDeArea();
                }              
            })
            .catch(e => {
                console.log("No Hay Respuesta del Servidor" + e);
                comun.SeEstaCargandoInformacion(false);
                clearInterval(this.$store.state.SICCIJ_AgendarCita_TemporizadorFechaHoraSeleccionada);
                this.$store.state.SICCIJ_AgendarCita_TemporizadorFechaHoraSeleccionada = null;
            });
        },
        /**
         * Función encargada de actualizar el id de materia en los parámetros de materias, tipos de documentos e información de tramintes expedientes
         * @param {int} id [valor que representa el id de la materia seleccionada]
         */
        cambioMateria(id) {
            this.parametros_Materias.MateriaSeleccionadaId = id;
            this.parametros_Temporales.MateriaId = id;
            this.parametros_TiposDocumentos.MateriaId = id;
            if(this.parametros_Materias.MateriaSeleccionadaId > 0)
            {
                /*$("#catalogoMaterias").attr('disabled','disabled');
                this.parametros_TiposTramites.TipoTramiteSeleccionadoId = null;
                this.parametros_TiposTramites.TipoTramite = null;*/
                this.parametros_Materias.deshabilitarSelectMaterias = true;
                this.informacionTramitesExpedientesYConfiguracion.MateriaId = id;
            }
            else
            {
                this.parametros_Materias.deshabilitarSelectMaterias = false;
            }
        },
        /**
         * Función encargada de cambiar la materia cuando el componente desencadena el evento de cambio en el select
         * @param {} datos [valor que representa el evento del cambio de materia]
         */
        triggerCambioMateria(datos) {
            this.cambioMateria(parseInt(datos.target.value));
            this.parametros_Materias.nombre = $("#catalogoMaterias option:selected").text();
            this.parametros_Temporales.Materia = this.parametros_Materias.nombre;
        },
        /**
         * Función encargada de cambiar el tipo de trámite cuando el componente desencadena el evento de cambio en el select
         * @param {Array} datos [tiene dos valores, el primero el evento del cambio de tipo de trámite y el segundo el objeto del tipo de trámite seleccionado]
         */
        cambioTipoTramite(datos) {
            var datosEvento = datos[0];
            this.parametros_TiposTramites.TipoTramite = datos[1];
            this.parametros_TiposTramites.nombre = $("#catalogoTiposTramites option:selected").text();
            this.parametros_TiposTramites.TipoTramiteSeleccionadoId = parseInt(datosEvento.target.value);
            this.parametros_Temporales.TipoTramite = this.parametros_TiposTramites.nombre;
            this.parametros_Temporales.TipoTramiteId = this.parametros_TiposTramites.TipoTramiteSeleccionadoId;
        },
        /**
         * Función encargada de cambiar el tipo de documento cuando el componente desencadena el evento de cambio en el select y asigna el v-mask y placeholder en número de expediente
         * @param {} datos [valor que representa el evento del cambio de tipo de documento]
         */
        cambioTipoDocumento(id){
            //this.parametros_TiposDocumentos.nombre = $("#catalogoTiposDocumentos option:selected").text();
            this.parametros_TiposDocumentos.TipoDocumentoSeleccionadoId = id;
            if(id == 2 || id == 10)
            {
                this.vmaskNumeroExpediente = '####/####-##';
                $("#numeroDelExpediente").attr("placeholder", "0150/2020-8");//.placeholder = "0150/2020-8";
                this.tipoNumExpedienteEspecial = true;
            }
            else
            {
                this.vmaskNumeroExpediente = '####/####';
                $("#numeroDelExpediente").attr("placeholder", "0150/2020");//.placeholder = "0150/2020";
                this.tipoNumExpedienteEspecial = false;
            }
            
        },
        /**
         * Función encargada de cambiar la materia cuando el componente desencadena el evento de cambio en el select
         * @param {} datos [valor que representa el evento del cambio de materia]
         */
        triggerCambioTipoDocumento(datos)
        {
            this.cambioTipoDocumento(parseInt(datos.target.value));
            this.parametros_TiposDocumentos.nombre = $("#catalogoTiposDocumentos option:selected").text();
        },
        /**
         * Función encargada de habilitar el componente de seleccionar área
         */
        habilitarSelectAreas: function()
        {
            $('#catalogoAreas').val(-1);
            $("#catalogoAreas").removeAttr('disabled');
            this.parametros_Areas.deshabilitarSelectAreas = false;
        },
        /**
         * Función encargada de habilitar el componente de seleccionar materia
         */
        habilitarSelectMaterias: function()
        {
            $('#catalogoMaterias').val(-1);
            //$("#catalogoMaterias").removeAttr('disabled');
            this.parametros_Materias.deshabilitarSelectMaterias = false;
        },
        habilitarSeccionExpedientes: function()
        {
            if(this.parametros_TiposTramites.TipoTramiteSeleccionadoId != 6)
            {
                $("#botonCrearTramite").blur();
                this.agregandoExpedientes= true;
            }
            else 
            {
                this.agregarTramite();
            }
        },
        /**
         * Función encargada de llamar a API y obtener las configuraciones de bloques, horario de atención y trámites del área seleccionada
         */
        obtenerConfiguracionesDeArea()
        {
            this.parametros_ConfiguracionCitasDeArea.EsPrueba = this.enumeraciones.EsPrueba;           
            axios.post(api.conexion + api.SICCIJ.sistema.citas.AgendarCita.ObtenerConfiguracionesDeArea, this.parametros_ConfiguracionCitasDeArea)
            .then(respuesta => {            
                if (respuesta.data.SiHayError) {
                    console.log(respuesta);
                    this.limiteExpedientesDefault=3;
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                } else {              
                    this.informacionTramitesExpedientesYConfiguracion.ConfiguracionCitasDeArea = respuesta.data.ConfiguracionCitasDeArea;
                    this.informacionTramitesExpedientesYConfiguracion.TiemposTramitesPorArea = respuesta.data.TiemposTramitesPorArea;
                    this.limiteExpedientesDefault = this.informacionTramitesExpedientesYConfiguracion.ConfiguracionCitasDeArea.ExpedientePorCita;
                    //$("#catalogoAreas").trigger("change");
                }
            })
            .catch(excepcion => {
                console.log(excepcion);
                comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
            })
        },
        /**
         * Función encargada de verificar que el id proporcionado tenga un valor y que este sea mayor a 0
         * @param {int} id [valor que representa un valor número id de alguna secuencia]
         */
        verificarValorId(id)
        {
            return (id != undefined && id != null && id > 0);
        },
        /**
         * Función encargada de verificar que el listado proporcionado tenga información
         * @param {Array} listado [listado de elementos]
         */
        verificarListadoConInformacion(listado)
        {
            return (listado != undefined && listado != null && listado.length > 0);
        },
        /**
         * Función encargada de verificar que el número de expediente tenga un valor y año válido
         * @param {Bool} mostrarMensajesError [valor que representa si al verificar expediente se muestran mensajes de error]
         */
        verificarExpediente(mostrarMensajesError)
        {
            if((!this.tipoNumExpedienteEspecial && this.numeroDelExpediente.length == 9) || (this.tipoNumExpedienteEspecial && this.numeroDelExpediente.length >= 11))
            {
                var expediente =  parseInt(this.numeroDelExpediente.split("/")[0]);
                var año = parseInt(this.numeroDelExpediente.split("/")[1].split("-")[0]);
                if(expediente > 0 && año > 1900 && año <= parseInt(moment().format('YYYY')))
                    return true;
                else if(mostrarMensajesError) 
                    comun.mensajeDeAlerta("El número de expediente no es válido, verifique e intente de nuevo.", null, null);
            }
            else if(this.numeroDelExpediente.length == 0 && this.parametros_TiposTramites.TipoTramiteSeleccionadoId == 6)
                return true;
            else if( this.numeroDelExpediente.length > 0 && mostrarMensajesError) 
                comun.mensajeDeAlerta("El número de expediente no está completo, verifique e intente de nuevo.", null, null);
            else if(mostrarMensajesError)
                comun.mensajeDeAlerta("No ha ingresado número de expediente, verifique e intente de nuevo.", null, null);
            
            return false;
        },
        /**
         * Función encargada de verificar que se pueda habilitar el select de áreas de lo contrario llamar a la función para mostrar mensaje de perdida de cambios
         */
        verificarParaHabilitarSelectAreas()
        {
            if(this.verificarListadoConInformacion(this.informacionTramitesExpedientesYConfiguracion.ListadoTramites))
            {
                this.mensajeEliminarInformacion("cambiar juzgado");
            }
            else
            {
                this.limpiarDatosTramites();
                this.habilitarSelectAreas();
            }
        },
        /**
         * Función encargada de limpiar los datos de expediente (tipo de documento y número de documento)
         */
        limpiarDatosExpediente:function()
        {
            this.parametros_TiposDocumentos.TipoDocumentoSeleccionadoId = null;
            this.parametros_TiposDocumentos.nombre = "";
            this.numeroDelExpediente = "";
            $('#catalogoTiposDocumentos').val(-1);
            this.vmaskNumeroExpediente = '####/####'
            $("#numeroDelExpediente").attr("placeholder", "0150/2020");
            this.tipoNumExpedienteEspecial = false;
            this.mostrarErrores = false;
        },
        /**
         * Función encargada de limpiar los datos de trámites, listado, contadores, limites y banderas de mostrar mensajes de error.
         */
        limpiarDatosTramites:function()
        {
            this.informacionTramitesExpedientesYConfiguracion.ListadoTramites = [];
            this.contadorTemporalExpedientesDeCita = 0;
            this.contadorExpedientesDeCita = 0;
            this.limiteDeExpedientes = false;
            this.contadorTramitesQueExcedenTiempo = 0;
            this.mensajeTiempoExcede=false;
            this.tiempoExcede=null;
        },
        /**
         * Función encargada agregar trámite al listado de trámites
         */
        agregarTramite:function()
        {
            this.agregandoExpedientes=false;
            //#region [push a Listado de Tramites]
                var TramiteCita ={};
                TramiteCita.nombre = this.parametros_Temporales.TipoTramite;//this.parametros_TiposTramites.nombre;
                TramiteCita.CitaId = 0;
                TramiteCita.TipoTramiteId = this.parametros_Temporales.TipoTramiteId;//this.parametros_TiposTramites.TipoTramiteSeleccionadoId;
                if(!this.verificarListadoConInformacion(this.listadoExpedientes))
                    this.agregarExpediente();
                TramiteCita.Expedientes = this.listadoExpedientes;   
                TramiteCita.materiaNombre = this.parametros_Temporales.Materia;//$("#catalogoMaterias option:selected").text();
                this.contadorExpedientesDeCita = this.contadorTemporalExpedientesDeCita;
                this.informacionTramitesExpedientesYConfiguracion.ListadoTramites.push(TramiteCita);
                if(this.informacionTramitesExpedientesYConfiguracion.TiemposTramitesPorArea[TramiteCita.TipoTramiteId] > this.informacionTramitesExpedientesYConfiguracion.ConfiguracionCitasDeArea.TiempoPorBloque)
                {
                    this.mensajeTiempoExcede = true;
                    this.contadorTramitesQueExcedenTiempo++;
                    if(this.tiempoExcede == undefined || this.tiempoExcede == null || this.tiempoExcede < this.informacionTramitesExpedientesYConfiguracion.TiemposTramitesPorArea[TramiteCita.TipoTramiteId])
                        this.tiempoExcede = this.informacionTramitesExpedientesYConfiguracion.TiemposTramitesPorArea[TramiteCita.TipoTramiteId];
                }
            //#endregion

            //#region Limpiar listado de expedientes y verificar contador de expedientes
                this.listadoExpedientes = [];
                $('#catalogoTiposTramites').val(-1);
                this.parametros_TiposTramites.TipoTramiteSeleccionadoId = null;
                this.parametros_Temporales.TipoTramiteId = null;
                this.parametros_Temporales.TipoTramite = '';
                this.parametros_Temporales.MateriaId =  $("#catalogoMaterias option:selected").val();
                this.parametros_Temporales.Materia = $("#catalogoMaterias option:selected").text();

                if(this.contadorExpedientesDeCita >= this.limiteExpedientesDefault)
                {
                    this.limiteDeExpedientes = true;
                    /*$("#catalogoTiposTramites").attr('disabled','disabled');
                    $("#botonCrearTramite").attr('disabled','disabled');
                    $("#botonCrearTramite").blur();*/
                }
            //#endregion
        },
        /**
         * Función encargada modificar trámite del listado de trámites
         */
        modificarTramite:function(indexDeElemento)
        {
            if(indexDeElemento > -1) 
            {
                //#region [obtener trámite de Listado de Tramites]
                    var TramiteCita = this.informacionTramitesExpedientesYConfiguracion.ListadoTramites[indexDeElemento];
                    
                    this.parametros_Temporales.TipoTramiteId = TramiteCita.TipoTramiteId;
                    this.parametros_Temporales.TipoTramite = TramiteCita.nombre;
                    this.parametros_Temporales.Materia = TramiteCita.materiaNombre;
                    this.parametros_Temporales.MateriaId = TramiteCita.Expedientes[0].MateriaId_002DBPJ;
                    this.listadoExpedientes = TramiteCita.Expedientes;  
                    let contadorExp = this.contadorExpedientesDeCita;
                    /*this.contadorTemporalExpedientesDeCita = this.contadorExpedientesDeCita;
                    this.contadorExpedientesDeCita = this.contadorExpedientesDeCita - TramiteCita.Expedientes.length;*/
                    /*
                    if(this.informacionTramitesExpedientesYConfiguracion.TiemposTramitesPorArea[TramiteCita.TipoTramiteId] > this.informacionTramitesExpedientesYConfiguracion.ConfiguracionCitasDeArea.TiempoPorBloque)
                    {
                        this.contadorTramitesQueExcedenTiempo--;
                        if(this.contadorTramitesQueExcedenTiempo <= 0)
                        {
                            this.mensajeTiempoExcede = false;
                            this.tiempoExcede = null;
                        }
                        //else if(this.tiempoExcede == undefined || this.tiempoExcede == null || this.tiempoExcede < this.informacionTramitesExpedientesYConfiguracion.TiemposTramitesPorArea[TramiteCita.TipoTramiteId])
                        //{
                        //    var tiempoMayorTramites = Math.max.apply(Math, this.informacionTramitesExpedientesYConfiguracion.TiemposTramitesPorArea);
                        //}
                        //    this.tiempoExcede = this.informacionTramitesExpedientesYConfiguracion.TiemposTramitesPorArea[TramiteCita.TipoTramiteId];
                    }*/
                //#endregion

                //#region Eliminar Trámite
                    this.eliminarTramite(indexDeElemento);
                    this.contadorTemporalExpedientesDeCita = contadorExp;
                    this.habilitarSeccionExpedientes();
                //#endregion
            }   
            else comun.mensajeDeAlerta("Sucedió un error, no se puede modificar el elemento seleccionado.", null, null);
        },
        /**
         * Función encargada de eliminar trámite del listado de trámites
         * @param {int} indexDeElemento [valor que representa el indice del elemento a eliminar del listado]
         */
        eliminarTramite:function(indexDeElemento)
        {
            if(indexDeElemento > -1) 
            {
                let numExpedientes = this.informacionTramitesExpedientesYConfiguracion.ListadoTramites[indexDeElemento].Expedientes.length;
                if(this.informacionTramitesExpedientesYConfiguracion.TiemposTramitesPorArea[this.informacionTramitesExpedientesYConfiguracion.ListadoTramites[indexDeElemento].TipoTramiteId] > this.informacionTramitesExpedientesYConfiguracion.ConfiguracionCitasDeArea.TiempoPorBloque)
                {
                    this.contadorTramitesQueExcedenTiempo --;
                    if(this.contadorTramitesQueExcedenTiempo == 0)
                    {
                        this.mensajeTiempoExcede=false;
                        this.tiempoExcede=null;
                    }
                }
                this.informacionTramitesExpedientesYConfiguracion.ListadoTramites.splice(indexDeElemento, 1);
                this.contadorExpedientesDeCita = this.contadorExpedientesDeCita - numExpedientes;
                this.contadorTemporalExpedientesDeCita = this.contadorExpedientesDeCita;
                if(this.contadorExpedientesDeCita<this.limiteExpedientesDefault)
                {
                    this.limiteDeExpedientes = false;
                    /*$("#catalogoTiposTramites").removeAttr('disabled');
                    $("#botonCrearTramite").removeAttr('disabled');*/
                }
            }   
            else comun.mensajeDeAlerta("No se pudo eliminar el elemento seleccionado.", null, null);
        },
        /**
         * Función encargada de cancelar cuando hay un trámite en curso, verifica que no haya información agregada, de haberlo muestra un mensaje de perdida de cambios.
         */
        cancelarTramite:function()
        {
            if(this.verificarListadoConInformacion(this.listadoExpedientes))
            {
                bootbox.confirm({
                    title: "Mensaje del sistema",
                    message: "Hay información agregada. Si decide cancelar el trámite, perderá los cambios realizados.<br />¿Desea continuar?",
                    buttons: {
                        cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Regresar'
                        },
                        confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Continuar y cancelar trámite'
                        }
                    },
                    callback: (respuestaCancelarTramite) => {
                        if (respuestaCancelarTramite) {
                            this.limpiarDatosExpediente();
                            this.listadoExpedientes=[];
                            this.agregandoExpedientes=false;
                            this.contadorTemporalExpedientesDeCita=this.contadorExpedientesDeCita;
                        }
                    }
                });
            }
            else
            {
                this.agregandoExpedientes=false;
                this.limpiarDatosExpediente();
            }   
        },
        /**
         * Función encargada de agregar expediente al listado de expedientes de trámite
         */
        agregarExpediente:function()
        {
            if(this.verificarValorId(this.parametros_TiposDocumentos.TipoDocumentoSeleccionadoId) || this.parametros_TiposTramites.TipoTramiteSeleccionadoId == 6)
            {
                if(this.verificarExpediente(true))
                {
                    let expediente ={};
                    expediente.NumeroDeExpediente = (this.numeroDelExpediente.length >= 9) ? this.numeroDelExpediente : null;
                    expediente.TipoDocumentoId_004DBPJ = this.verificarValorId(this.parametros_TiposDocumentos.TipoDocumentoSeleccionadoId) ? this.parametros_TiposDocumentos.TipoDocumentoSeleccionadoId : null;
                    expediente.AreaId = this.parametros_Areas.AreaSelecccionadaId;
                    expediente.MateriaId_002DBPJ = this.parametros_Temporales.MateriaId;//this.parametros_Materias.MateriaSeleccionadaId;
                    expediente.tipoDeDocumento = this.verificarValorId(this.parametros_TiposDocumentos.TipoDocumentoSeleccionadoId) ? this.parametros_TiposDocumentos.nombre : "";
                    //expediente.materia = this.parametros_Materias.nombre;

                    this.listadoExpedientes.push(expediente);
                    this.contadorTemporalExpedientesDeCita ++; 
                    if(this.parametros_TiposTramites.TipoTramiteSeleccionadoId != 6)
                        this.limpiarDatosExpediente();
                }   
                else this.mostrarErrores = true;
            }
            else 
            {
                comun.mensajeDeAlerta("Seleccione un tipo de documento.", null, null);
                this.mostrarErrores = true;
            }
        },
        /**
         * Función encargada de modificar un expediente del listado de expedientes
         * @param {int} indexDeElemento [valor que representa el indice del elemento a modificar del listado]
         */
        modificarExpediente:function(indexDeElemento)
        {
            //debugger;
            if(indexDeElemento > -1) 
            {
                this.contadorTemporalExpedientesDeCita --; 
                //$('#catalogoTiposDocumentos option[value=' + this.listadoExpedientes[indexDeElemento].TipoDocumentoId_004DBPJ + ']').attr('selected','selected');
                $('#catalogoTiposDocumentos').val(this.listadoExpedientes[indexDeElemento].TipoDocumentoId_004DBPJ);
                $('#catalogoTiposDocumentos option[value="'+this.listadoExpedientes[indexDeElemento].TipoDocumentoId_004DBPJ+'"]').prop('selected', true);//.attr('selected','selected');
                this.parametros_TiposDocumentos.nombre = this.listadoExpedientes[indexDeElemento].tipoDeDocumento;
                this.cambioTipoDocumento(this.listadoExpedientes[indexDeElemento].TipoDocumentoId_004DBPJ);
                this.numeroDelExpediente = this.listadoExpedientes[indexDeElemento].NumeroDeExpediente;
                this.listadoExpedientes.splice(indexDeElemento, 1);
            }   
            else comun.mensajeDeAlerta("Sucedió un error, no se puede modificar el elemento seleccionado.", null, null);
        },
        /**
         * Función encargada de eliminar expediente del listado de expedientes
         * @param {int} indexDeElemento [valor que representa el indice del elemento a eliminar del listado]
         */
        eliminarExpediente:function(indexDeElemento)
        {
            if(indexDeElemento > -1) 
            {
                this.listadoExpedientes.splice(indexDeElemento, 1);
                this.contadorTemporalExpedientesDeCita --; 
            }   
            else comun.mensajeDeAlerta("No se pudo eliminar el elemento seleccionado.", null, null);
        },
        /**
         * Función encargada de mostrar mensaje de se perderá información cuando se decide cambiar de área.
         * @param {String} mensaje [valor que representa el componente al que hace referencia el mensaje de perdida de cambios]
         */
        mensajeEliminarInformacion: function(mensaje)
        {
            bootbox.confirm({
                title: "Mensaje del sistema",
                message: "Hay información agregada. Si decide " + mensaje +", perderá los tramites agregados.<br />¿Desea continuar?",
                buttons: {
                    cancel: {
                    label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Regresar'
                    },
                    confirm: {
                    label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Continuar y '+ mensaje
                    }
                },
                callback: (respuestaCambiar) => {
                    if (respuestaCambiar) {
                        this.limpiarDatosTramites();
                        this.habilitarSelectAreas();
                    }
                }
            });
        },
        /**
         * Función encargada de generar el objeto que se enviará al componente padre y enviarlo.
         */
        crearObjetoYSiguiente: function()
        {
            bootbox.confirm({
                title: "Mensaje del sistema",
                message: "El siguiente paso es elegir la fecha y hora de su cita.<br />Considere que:<br /><ul><li>No podrá agendar más de una cita para un mismo juzgado en el mismo día.</li><li>No podrá agendar una cita si hay conflicto de horarios en su agenda de citas a juzgados.</li><li>El calendario se cargará con base en los trámites seleccionados para su cita, los cuales pueden variar entre 15 min. o 30 min.</li><li>El calendario se actualizará cada minuto.</li><li>Asegúrese de tener habilitadas las <b style='color:yellow;'>ventanas emergentes</b> en su navegador para poder generar e imprimir su comprobante de cita.</li></ul>¿Desea continuar?",
                buttons: {
                    cancel: {
                    label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Regresar'
                    },
                    confirm: {
                    label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar y continuar'
                    }
                },
                callback: (respuestacancelarCita) => {
                    if (respuestacancelarCita) 
                    {
                        this.informacionTramitesExpedientesYConfiguracion.Siguiente = true;
                        this.$emit("valorParaElPadreJuzgadoTramitesExpedientes", this.informacionTramitesExpedientesYConfiguracion);
                    }
                }
            });            
        },
        /**
         * Función encargada de regresar el componente de Datos de Solicitante.
         */
        regresarADatosSolicitante: function()
        {
            this.informacionTramitesExpedientesYConfiguracion.Siguiente = false;
            this.$emit("valorParaElPadreJuzgadoTramitesExpedientes", this.informacionTramitesExpedientesYConfiguracion);
        },
        /**
         * Función encargada de cancelar el agendar cita.
         */
        cancelarCita: function()
        {
            bootbox.confirm({
                title: "Mensaje del sistema",
                message: "Hay información agregada. Si decide cancelar el proceso de agendar cita, perderá toda la información ingresada.<br />¿Desea continuar?",
                buttons: {
                    cancel: {
                    label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Regresar'
                    },
                    confirm: {
                    label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Continuar y cancelar cita'
                    }
                },
                callback: (respuestacancelarCita) => {
                    if (respuestacancelarCita) 
                        this.$router.go();
                }
            });
            //router.push({name: 'AgendarCita'});                    
        }
    }
  }
</script>

<style scoped>
    .padding-div-low {
        padding-top: 40px;
    }
    .contenedor-puntero {
        background: #636369;
        border-radius:2px;
        padding: 10px;
        border:1px solid black;
        margin-bottom: 1.5em;
    }
    .espacio_base{
        min-width: 200px;
        width: 30%;
        max-width: 350px;
        margin-right: 1em;
        display: inline-block;
        margin-bottom: 1em;
    }
    .wrapDivBloqueado
    {
        opacity: 0.7;
        cursor: not-allowed;
    }
    .bloquearDiv{
        pointer-events: none;
    }
    #juzgadoMateriaTramite_div .btn{
        height: auto;
        min-width: 50%;
        max-width: 100%;
        white-space: normal;
        text-align: center;
    }
    #tramitesExpedientes_div .btn{
        height: auto;
        white-space: normal;
        text-align: center;
    }
    #tramitesExpedientes_div .ancho_botones
    {
        max-width: 30%;
    }
    .campos_expedientes h6 { display:inline; margin-right: 1em; }
    #tiposDocs
    {
        border-radius: 2px;
    }
    .fadeHeight-enter-active,
    .fadeHeight-leave-active {
        transition: all 2s;
        max-height: 900px;
    }
    .fadeHeight-enter,
    .fadeHeight-leave-to
    {
        opacity: 0;
        max-height: 0px;
    }
    .fade-enter-active, .fade-leave-active {
        max-width: 10%;
        transition: width 2s opacity 2s;
    }
    .fade-enter, .fade-leave-to  {
        max-width: 0;
        opacity: 0;
    }
</style>
<style scoped>
    #tiposDocs > .form-group
    {
        margin-bottom: 0 !important;
    }

    .form-control {
        background-color: white;
        color: rgb(63, 62, 62);
        border: 1px solid #656161 !important;
    }
    .table-header-global{
      background-color: #004746;
    }   

    .card-body {
        background-color: #bebebc;
        padding: 2em 2em 2em 2em !important;
        border: 1px solid rgb(44, 44, 44);
    }

    .card-header {
        background-color: #007573;
        border: 1px solid rgb(44, 44, 44);

    }
    .text-form {
        padding:10px; 
        line-height: 1; 
        color: black;
    }
    .text-form-note {
         
        line-height: 1; 
        color: black;
    }
</style>


// WEBPACK FOOTER //
// src/components/SICCIJ/Citas/AgendarCitas/JuzgadoTramitesExpedientes.vue